/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PostPatientResetPasswordRequestBodyTypename = "PostPatientResetPasswordRequestBody" as const;

/**
 *
 * @export
 * @interface PostPatientResetPasswordRequestBody
 */
export interface PostPatientResetPasswordRequestBody {
  /**
   *
   * @type {string}
   * @memberof PostPatientResetPasswordRequestBody
   */
  email: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PostPatientResetPasswordRequestBody
   */
  readonly __typename?: string;
}

export function PostPatientResetPasswordRequestBodyFromJSON(json: any): PostPatientResetPasswordRequestBody {
  return PostPatientResetPasswordRequestBodyFromJSONTyped(json, false);
}

export function PostPatientResetPasswordRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PostPatientResetPasswordRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PostPatientResetPasswordRequestBodyTypename,

    email: json["email"],
  };
}

export function PostPatientResetPasswordRequestBodyToJSON(object?: PostPatientResetPasswordRequestBody | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    email: value.email,
  };
}
